import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { apiKey } from "../../../config/config";
import { useParams } from "react-router-dom";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { formatDateToInputValue } from "../../../config/helperFunctions";
import { useReactToPrint } from "react-to-print";

function ReturnReceipt({ general }) {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(true);
  const [data, setData] = useState();
  const [error, setError] = useState(false);

  const currentData = formatDateToInputValue(new Date());

  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Invoice",
  });

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/returns/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Cannot load data");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [id, user?.token]);

  if (error) {
    return <MessageCard error={error} />;
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }
  return (
    <main>
      <div className="flex flex-col gap-4 my-16">
        <div className="bg-white shadow-md rounded-lg p-4">
          <div ref={componentRef} className="max-w-lg mx-auto py-16">
            <div className="text-center text-[#7B20C7] mb-4">
              <h2 className="text-3xl font-semibold mb-2">
                {general?.restaurant_name}
              </h2>
              <p className="text-lg">{general?.address}</p>
              <p className="text-lg mb-6">Tel {general?.phone}</p>
              <p className="text-2xl text-black">
                Tax Registration No {general?.tax_reg_no}
              </p>
              <p className="text-lg">
                Return Invoice/{data?.invoice_no} :مرتجع رقم
              </p>
              <p className="text-lg">
                Reference Number/{data?.ref_no} :(الفاتورة) رقم المرجع
              </p>
              <p className="text-lg">Date: {data?.date_time}</p>
            </div>
            <table className="w-11/12 mx-auto">
              <thead>
                <tr>
                  <th className="text-sm text-start">SN</th>
                  <th className="text-sm text-start">Name</th>
                  <th className="text-sm text-start">Price</th>
                  <th className="text-sm text-start">Vat</th>
                  <th className="text-sm text-start">Qty</th>
                </tr>
              </thead>
              <tbody>
                {data?.details?.map((detail, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{detail.name}</td>
                    <td>{detail.price}</td>
                    <td>{detail.vat}</td>
                    <td>{detail.qty}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-6 text-center">
              <div className="text-[#7B20C7] text-xl">
                <p>Amount: {(data?.total_return_amount).toFixed(2)}</p>
                <p>Description: {data?.description}</p>
              </div>
              <div className="">
                <p>Statement Date: {currentData}</p>
                <p>Print Date: {currentData}</p>
              </div>
            </div>
            <div>
              <img
                className="mx-auto w-1/2 my-8"
                src={data.qr_img_url}
                alt=""
              />
              <p className="text-center mt-4 text-lg">
                QR الفاتورة الالكترونية
              </p>
            </div>
          </div>
          <button
            onClick={handlePrint}
            className="px-2 py-2 text-white relative bg-[#7B20C7] rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-32 mx-auto block mt-8"
          >
            Print
          </button>
        </div>
        <div></div>
      </div>
    </main>
  );
}

export default ReturnReceipt;
